import styles from "./Ministers.module.scss";
import buttonStyles from "../../../components/Button.module.scss";

const Ministers = () => {
  return (
    <section id="ministers" className={styles.ministers}>
      <div className={styles.title}>
        <h2>Words by</h2>
        <h3>serving ministers</h3>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.desc}>
          <h4>
            Here are the ministers who serve at the pulpit of IREC Stockholm on
            regular basis
          </h4>
          <p>
            Our ministers faithfully take turns to make a monthly visit to
            preach the Word of God, visiting all IREC Europe branches. Beside
            preaching at Sunday service, our ministers also teach through online
            platforms. Some guest preachers were also sent from time to time by
            the synod.
          </p>
          <a href="/service" className={buttonStyles.button}>
            Join our Sunday service
          </a>
        </div>
        <div className={styles.list}>
          <div className={styles.quote}>
            <div className={styles["quote-item"]}>
              “The biggest problem of humanity is that we are unable to love God
              with all our heart, all our soul, our mind and to love our fellow
              humans as ourselves. The good news is that through Jesus we are
              enabled to grow in love.”
              <div className={styles.subtitle}>
                <div
                  className={styles.profile}
                  style={{
                    backgroundImage: "url(thumbnail-billy.png)",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                ></div>
                <p>Rev. Dr. Billy Kristanto</p>
              </div>
            </div>
            {/* <div className={styles["quote-item"]}>
              “Asking Sana in Slack for someone’s actions from the last meeting,
              or our definition of retention—it’s a game-changer.”
              <div className={styles.subtitle}>
                <div
                  className={styles.profile}
                  style={{
                    backgroundImage: "url(thumbnail-jack.png)",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                ></div>
                <p>Rev. Jack Kawira</p>
              </div>
            </div> */}
            <div className={styles["quote-item"]}>
              “When we struggle to grow in God’s love, we can find assurance in
              the fact that He first loved us. We are able to love and accept
              God because He first loved us. The question, then, is whether we
              can fully accept that we are loved by God and, in doing so,
              embrace our need for His love.”
              <div className={styles.subtitle}>
                <div
                  className={styles.profile}
                  style={{
                    backgroundImage: "url(thumbnail-leonardo.png)",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                ></div>
                <p>Vic. Leonardo Chandra</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ministers;
